import { type IconLibrary } from 'src/components/DynamicIcon/dynamic-icon';
import { PartnerGroupRules, UserGroupRules } from 'src/graphql';

export enum ClientTabs {
  Sites = 'sites',
  Conversations = 'conversations',
  Activity = 'activity',
}

export type ClientTab = {
  label: string;
  value: ClientTabs;
  /**
   * URL segment for the full-page deep link (`/clients/{id}/{slug}`). Kept separate from
   * `value` so the public URL contract does not inherit the enum values.
   */
  slug: string;
  icon: string;
  iconLibrary?: IconLibrary;
  allowedRules?: (UserGroupRules | PartnerGroupRules)[];
};

export const CLIENT_TABS: ClientTab[] = [
  {
    value: ClientTabs.Sites,
    slug: 'sites',
    label: 'Sites',
    icon: 'building-2',
    iconLibrary: 'lucide',
  },
  {
    value: ClientTabs.Conversations,
    slug: 'conversations',
    label: 'Conversations',
    icon: 'messages-square',
    iconLibrary: 'lucide',
  },
  {
    value: ClientTabs.Activity,
    slug: 'activity',
    label: 'Activity',
    icon: 'history',
    iconLibrary: 'lucide',
    allowedRules: [UserGroupRules.AccessToActivityFeedInClients],
  },
];
